<template>
	<div
		class="invalid-payment-modal"
		:class="{'invalid-payment-modal--closed': closed}"
		role="dialog"
		aria-modal="true"
		:aria-hidden="closed ? 'true' : 'false'"
		@click.self="close"
	>
		<section class="invalid-payment-modal__content">
			<header class="invalid-payment-modal__header">
				<h2>{{translation.title}}</h2>
				<button type="button" aria-label="Close" @click="close">&times;</button>
			</header>
			<div class="invalid-payment-modal__body">
				<p>{{translation.text}}</p>
			</div>
		</section>
  </div>
</template>

<script>
import PaymentMethods from '../../enums/PaymentMethods';
import { translate } from '../../assets/translations';
export default {
  computed: {
    translation() {
      let translation = translate(this.$store.state.language).invalidPaymentMessage;
      return this.paymentMethod.type === this.PaymentMethods.BANK_TICKET.type? translation.bankTicket : translation.creditCard;

    }
  },
	data(){
		return{
			closed: true,
			title: '',
			message: '',
      PaymentMethods,
      paymentMethod: {type:null}
		};
  },
  methods:{
		open(paymentMethod){
      this.paymentMethod = paymentMethod ? paymentMethod : {type:'credit-card'};
			this.closed = false;
    },
    close(){
      this.closed = true;
    },
  }
}
</script>
<style scoped lang="scss">
.invalid-payment-modal--closed {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.invalid-payment-modal {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 2000;
  inset: 0;
  padding: 9px;
  overflow-y: auto;
  background: rgba(0, 0, 0, .55);
  opacity: 1;
  transition: visibility .2s, opacity .2s linear;
}

.invalid-payment-modal__content {
  width: 100%;
  max-width: 560px;
  overflow: hidden;
  border-radius: 13px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(0, 0, 0, .25);
}

.invalid-payment-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 53px;
  padding: 0 11px 0 20px;
  background: #67adc6;
  color: #ffffff;
}

.invalid-payment-modal__header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}

.invalid-payment-modal__header button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.invalid-payment-modal__header button:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: -4px;
}

.invalid-payment-modal__body {
  box-sizing: border-box;
  min-height: 97px;
  padding: 24px;
  color: #4c4b4b;
}

.invalid-payment-modal__body p {
  margin: 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/InvalidCreditCardModal.vue